import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    color: theme.palette.text.link,
    flexGrow: 100,
    padding: 10,
  },
  inError: {
    backgroundColor: theme.palette.error.main,
    cursor: 'no-drop',
    color: theme.palette.white,
  },
}));
